import cartFieldsFragment from './cartFields.fragment'

export default `
  query customerCart {
    customerCart {
      ${cartFieldsFragment}
    }
  }
`
